import { Injectable, signal } from '@angular/core';

/**
 * Manages the light/dark theme by toggling the `dark` class on <html>.
 * The initial value is set pre-paint by the inline script in index.html
 * (default dark, honoring a saved choice or the system preference).
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly isDark = signal<boolean>(
    typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
  );

  toggle(): void {
    const next = !this.isDark();
    this.isDark.set(next);
    document.documentElement.classList.toggle('dark', next);
    try {
      localStorage.setItem('theme', next ? 'dark' : 'light');
    } catch {
      /* ignore */
    }
  }
}
